import React, { useState, useEffect, useMemo } from 'react';
import { Row, Col, Label, Input, ListGroup, ListGroupItem, FormGroup } from 'reactstrap';
import { useTranslation } from "react-i18next";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';
import { useParams, useNavigate } from "react-router-dom";
import CompLoaderDt from '../Common/CompLoaderDt';

function CompCrmAccessSettings() {
    const { t } = useTranslation();
    const [componentId] = useState('compCrmAccessSettings');
    const [data, setData] = useState(null);
    const [dataMyCrmDetails, setDataMyCrmDetails] = useState(null);
    const [dataLocked, setDataLocked] = useState(true);
    const [logged, setLogged] = useState(false);
    const [seed, setSeed] = useState(0);

    const params = useParams();
    let crmId = params.crmId;
    const [apiCalled, setApiCalled] = useState(false);
    const [apiCalledBy, setApiCalledBy] = useState(false);

    useEffect(() => {
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            if (crmId && crmId) {
                let currentSession = sessionStorage.getItem("currentSession");
                axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
                axios.defaults.headers.common["Authorization"] = currentSession !== null ? JSON.parse(currentSession)?.bearerToken : null;
                let ApiGateway = process.env.REACT_APP_API_URL;
                axios.get(ApiGateway + '/crm/crm/' + crmId + '/find-and-get')
                    .then(response => {
                        setData(response?.data);
                        setEMail(response?.data?.payload?.email);
                        setLoginPermissionAllowed(response?.data?.payload?.emailSendingAllowed);
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        }
    }, [t, crmId]);

    const [email, setEMail] = useState('');
    const [loginPermissionAllowed, setLoginPermissionAllowed] = useState(false);

    const callAccessSettingsUpdate = (apiRequestBody) => {
        callAccessSettingsUpdateService(apiRequestBody);
        setApiCalledBy('Approval');
        setApiCalled(true);
        setSeed(Math.random());
    }

    const callAccessSettingsUpdateService = React.useCallback((apiRequestBody) => {
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            let currentSession = sessionStorage.getItem("currentSession");
            axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
            axios.defaults.headers.common["Authorization"] = currentSession !== null ? JSON.parse(currentSession)?.bearerToken : null;
            let ApiGateway = process.env.REACT_APP_API_URL;
            axios.put(ApiGateway + '/market-place/trader/my-crm-notification-settings/update', apiRequestBody)
                .then(response => {
                    if (response.data?.isSucceed === true) {
                        setApiCalled(false);
                        let message = t('api.default.service.response.succeded');
                        toast.success(message, { autoClose: 500 });
                        setTimeout(() => {
                            let redirectUrl = '/crm/' + crmId + '/accessSettings';
                            window.location.href = redirectUrl;
                        }, 500);
                    } else {
                        setApiCalled(false);
                        response.data?.messages?.forEach(
                            item => toast.error(item.message, { autoClose: 5000 })
                        );
                    }

                })
                .catch(error => {
                    console.error(error);
                });
        }
    }, [t, crmId]);

    return (
        <React.Fragment>
            <ToastContainer />
            {data ? ((
                <>
                    <Row className="mt-3 mb-3">
                        <Col className={"col-md-6"}>
                            <Label className="form-label">{t('components.crm.comp-access-settings.form.label.access-details')}</Label>
                        </Col>
                    </Row>
                    <Row className={'mb-3'}>
                        <Col lg={6}>
                            <Label className="form-label">{t('components.crm.comp-access-settings.form.label.username')}</Label>
                            <Input type="text" className="form-control"
                                disabled={dataLocked === true ? "disabled" : ""}
                                onChange={(e) => setEMail(e.target.value)} onKeyUp={(e) => setEMail(e.target.value)} value={email}
                                placeholder={t('components.crm.comp-access-settings.form.placeholder.username')} />
                        </Col>
                        <Col lg={6}>

                        </Col>
                    </Row>


                    <Row>
                        <Col>
                            <Label className="form-label " style={{}}>{t('components.crm.comp-access-settings.access-settings')}</Label>
                            <ListGroup style={{}}>
                                <ListGroupItem style={{}}>
                                    <Row>
                                        <Col lg={1}>
                                            <div className="mb-3 mb-lg-0">
                                                <div className="mb-0">
                                                    <FormGroup switch>
                                                        <Input
                                                            type="switch"
                                                            checked={loginPermissionAllowed}
                                                            onClick={() => {
                                                                setLoginPermissionAllowed(!loginPermissionAllowed);
                                                                callAccessSettingsUpdate(
                                                                    {
                                                                        loginPermissionAllowed: !loginPermissionAllowed
                                                                    });
                                                            }}
                                                        />
                                                    </FormGroup>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={11}>
                                            <h6 style={{ fontWeight: 'bold' }}>{t('components.crm.comp-access-settings.form.label.access')}</h6>
                                            {t('components.crm.comp-access-settings.form.label.access-description')}
                                        </Col>
                                    </Row>
                                </ListGroupItem>
                            </ListGroup>
                        </Col>
                    </Row>
                </>
            )) : (
                <Row>
                    <Col className={"col-md-12 text-center"}>
                        <CompLoaderDt />
                    </Col>
                </Row>
            )}
        </React.Fragment>
    );
}
export default CompCrmAccessSettings;